
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, CivilStatus, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class CivilStatusListProvider implements Resolve<any> {
    civilStatus: CivilStatus[];
    civilStatusEdit: CivilStatus;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.civilStatusEdit = this.state?.currentCivilStatus;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<CivilStatus> {
        if (!id) {
            return null;
        }
        return this.gw.get('civilStatus/:id', { id: id });
    }

    get currentCivilStatus(): CivilStatus {
        return this.civilStatusEdit;
    }

    getAll(entity?: String): Promise<any> {
        let urlPath = 'civilStatus/';
        if (entity) {
            urlPath = entity + urlPath
        }
        return new Promise((resolve, reject) => {
            this.gw.get(urlPath).subscribe((res: HttpResponse<any>) => {
                this.civilStatus = res.body;
                this.onDataChanged.next(this.civilStatus);
                resolve(res);
            }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('civilStatus/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.civilStatus, res.body.content) && res.body.content.length > 0) {
                    this.civilStatus = res.body.content;
                    this.onDataChanged.next(this.civilStatus);
                }
                else {
                    this.civilStatus = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

